var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKeyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 25,
    height: 23,
    rx: 3.5,
    stroke: "#999999"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3749_1414)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.25 6.16669L17.0833 7.33335M17.0833 7.33335L18.8333 9.08335L16.7917 11.125L15.0417 9.37502M17.0833 7.33335L15.0417 9.37502M12.6442 11.7725C12.9454 12.0697 13.1848 12.4235 13.3487 12.8136C13.5126 13.2038 13.5977 13.6224 13.5991 14.0456C13.6005 14.4687 13.5182 14.8879 13.357 15.2791C13.1957 15.6703 12.9586 16.0257 12.6594 16.3249C12.3602 16.6241 12.0048 16.8612 11.6136 17.0225C11.2224 17.1837 10.8032 17.266 10.38 17.2646C9.95691 17.2632 9.53824 17.1781 9.14814 17.0142C8.75803 16.8503 8.4042 16.6109 8.10701 16.3097C7.52258 15.7046 7.1992 14.8942 7.20651 14.0529C7.21382 13.2117 7.55124 12.407 8.14609 11.8122C8.74094 11.2173 9.54563 10.8799 10.3868 10.8726C11.2281 10.8653 12.0385 11.1887 12.6436 11.7731L12.6442 11.7725ZM12.6442 11.7725L15.0417 9.37502",
    stroke: "#999999",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3749_1414"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(6 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyIcon);
export default __webpack_public_path__ + "static/media/key_icon.3517104f906cbacc83e9cfcac75a0b2f.svg";
export { ForwardRef as ReactComponent };